
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/first-party-tracking",
      function () {
        return require("private-next-pages/events/first-party-tracking.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/first-party-tracking"])
      });
    }
  